// Versão da aplicação - ATUALIZAR A CADA DEPLOY
// Formato: vANO.MES.DIA.REVISAO
export const APP_VERSION = 'v2026.04.14';

// Data da última atualização
export const BUILD_DATE = '2026-04-01';

// Para verificar se a versão é válida
export const isVersionValid = (serverVersion) => {
  return APP_VERSION === serverVersion;
};
